
import {Component, Vue} from 'vue-property-decorator'
import UserGroupInfo from '@/model/modules/UserGroupInfo'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import FromUserInfo from '@/model/modules/FromUserInfo'
import FromUserService from '@/service/modules/FromUserService'

@Component
export default class UserGroupFromUserEditor extends Vue {
  item: UserGroupInfo = new UserGroupInfo()
  showState: boolean = false
  savingState: boolean = false
  saveSuccessCallback: any
  dataLoadingState: boolean = false

  allFromUserList: FromUserInfo[] = []
  selectedFromUser: { [index: number]: boolean } = {}

  mounted() {
    FromUserService.list({}, 0, 999999)
      .then((result: BasePageableInfo<FromUserInfo>) => {
        this.allFromUserList = result.dataList
      })
  }

  showEditor(item: UserGroupInfo, saveSuccessCallback: any) {
    this.item = JSON.parse(JSON.stringify(item))
    this.saveSuccessCallback = saveSuccessCallback
    this.showState = true
    this.selectedFromUser = {}
    this.dataLoadingState = true
    this.allFromUserList.forEach((fromUser: FromUserInfo) => {
      this.selectedFromUser[fromUser.id] = false
    })
    FromUserService.listWithUser({groupId: this.item.id}, 0, 999999)
      .then((resp: BasePageableInfo<FromUserInfo>) => {
        resp.dataList.forEach((fromUser: FromUserInfo) => {
          Vue.set(this.selectedFromUser, fromUser.id, true)
        })
        this.dataLoadingState = false
      })
  }

  saveEditor() {
    this.savingState = true
    const selectedIds: number[] = []
    for (const fromUserId in this.selectedFromUser) {
      if (this.selectedFromUser[fromUserId]) {
        selectedIds.push(Number(fromUserId))
      }
    }
    FromUserService.saveGroupFromUser(this.item.id, selectedIds)
      .then(() => {
        this.$alert('保存数据', '保存成功', {
          confirmButtonText: '确定'
        })
        this.savingState = false
        this.showState = false
        this.saveSuccessCallback()
      })
  }
}
